// src/api_scripts/get/getDialedNumberMappings.js
import { fetchAllPages } from "../paginationUtils";

const getDialedNumberMappings = async (unused, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/dial-number`;

  try {
    // Use the pagination utility to fetch all pages with higher page size for bulk export
    const dialedNumberMappingsArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Dialed Number Mappings", 1000);
    console.log("Get Dialed Number Mappings API Response Data (all pages):", dialedNumberMappingsArray.length, "items");
    return dialedNumberMappingsArray;

  } catch (error) {
    // If it's a 404, the API endpoint doesn't exist in this environment
    if (error.message && (error.message.includes('404') || error.message.includes('Request failed with status code 404'))) {
      console.warn(`Dialed Number Mappings API endpoint not available (404). This is expected in some environments.`);
      if (setProgress) {
        setProgress((prev) => [
          ...prev,
          { type: 'warning', message: 'Dialed Number Mappings API not available in this environment (404) - skipping', timestamp: new Date().toLocaleTimeString() }
        ]);
      }
      return []; // Return empty array instead of throwing error
    }

    console.error(`Error fetching Dialed Number Mappings:`, error);
    throw error; // Re-throw other errors
  }
};

export default getDialedNumberMappings;